import { useEffect, useState } from "react";
import {
  fetchHostedVideoPosterUrl,
  getFacebookVideoPageUrl,
  getHostedVideoPosterUrl,
  getLoomVideoId,
} from "../Utils/videoEmbedUrl";

/**
 * Resolves a click-to-play poster: sync URL first (YouTube/Vimeo/Loom guess),
 * then oEmbed / link-preview for Loom + Facebook when needed.
 */
export default function useHostedVideoPoster(url) {
  const trimmed = (url || "").trim();
  const [posterUrl, setPosterUrl] = useState(() =>
    getHostedVideoPosterUrl(trimmed),
  );

  useEffect(() => {
    let cancelled = false;
    const sync = getHostedVideoPosterUrl(trimmed);
    setPosterUrl(sync);

    if (!trimmed) return undefined;

    const needsFetch =
      getLoomVideoId(trimmed) || getFacebookVideoPageUrl(trimmed);
    if (!needsFetch) return undefined;

    (async () => {
      const resolved = await fetchHostedVideoPosterUrl(trimmed);
      if (!cancelled && resolved) {
        setPosterUrl(resolved);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [trimmed]);

  return posterUrl;
}
